import React, { Component } from "react";

import Header from "./component/Header";
import Service from "./component/Service";
import About from "./component/About";
import Counter from "./component/Counter.js";
import Activity from "./component/Activity.js";
import Team from "./component/Team.js";
import Process from "./component/Subjects.js";
import Testimonial from "./component/Testimonial.js";
import Footer from "./component/Footer.js";
import CustomSlider from "./component/Slider";
import VideoTestimonial from "./component/VideoTestimonial.js";

class Index extends Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }

    render() {
        return (
            <React.Fragment>
                <Header />
                <CustomSlider />
                <Service />
                <About />
                <Counter />
                <Activity />
                <Team />
                <Process />
                <VideoTestimonial />
                <Testimonial />
                <Footer />
            </React.Fragment>
        );
    }
}

export default Index;
